import MainRouter from './routes';
import './App.css';

function App() {
  return (
    <div className="App">
      <MainRouter />
    </div>
  );
}

export default App;
